import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/reducers.root'

export const modalSelect = (state: RootState) => state.modal

export const selectActiveModal = createSelector(modalSelect, (modal) => modal.modalConfig.variant)
